import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import { IImpersonation, IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import PluginService from "../../services/pluginService";
import { hasPluginConfigChanges } from "../../utils/pluginConfigChangeDetector";

const saveConfigImpersonationData = (configId: string, impersonationData: IImpersonation, token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({ type: ActionType.SAVE_CONFIG_PLUGIN_DATA });

        try {
      
            const { data: pluginConfiguration, persistedData } = getState().configPlugInData;

            if (!pluginConfiguration) {
                throw new Error(" No PluginConfiguration available in state to save");
            }

            const updatedConfig = {
                ...pluginConfiguration.Configuration,
                Impersonation: impersonationData
            };

            const hasChanges = hasPluginConfigChanges(updatedConfig, persistedData?.Configuration);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: { "Configuration": updatedConfig }
                });
                return false;
            }

            const configToSave = {
                ...updatedConfig,
                LastUpdateUtc: new Date().toISOString()
            };

            const requestBody = {
                "ConfigurationId": configId,
                "EncompassInstanceId": getState().appSlice.encompassInstanceId,
                "Configuration": configToSave
            };

            await new PluginService().saveEpcApiConfig<IPluginConfiguration>(token, "plugin", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                payload: { "Configuration": configToSave }
            });
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_PERSISTED,
                payload: { "Configuration": configToSave }
            });

            return true;

        } catch (error: any) {
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_FAILURE,
                payload: error.message
            });
            return Promise.reject(error.message);
        }
    };
};

export default saveConfigImpersonationData;